var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTtslogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_29",
    transform: "translate(0 0.0238095) scale(0.0104167 0.00992063)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_29",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADzklEQVR4nO2cu2sVQRSHvxUTRVRQVHwVhlhFIkZECxWJ/4CvoPaCraCVlXYKiiBGBVsbW3sVXygWKviKryAi8YUgMb4ixFjMXtAlibO7M+fszZ4PTjMJ95zz++2de3dm9oJhGIZhGIZhGIZhGIZh1IdO4CTwCPgKjJaM70AfcBpYKdhH0zENOAOMUF708WIE6AVahXpqGqYBV4gnfDYuYSb8w1nkxG9Er0hnTUAncaediaajzmwxU6K0WG32oNP3FGCvQt7K8Rj5q78Rj7PFJFFarDZDwEyl3D+AGX8PVMGABFgNbAE2AouApenf3gDvgevAReBegHyjAV6jDFXQHHCF7ASe4f8Wfgr0UK4JremnEZWgHbhD8SZuA20Fc9fegA3AB8o38gnYXCB/rQ3oBn4RrplhYFPOGmprQBvwcZyiyr4Tlueoo5YGJJSb8/8Xt/D/YK6lAbtyFFg0dnjWUjsDEvJ91SwafZ711M6ANSWKzRtdHvVUygCJRaktAjk0cgVBwoANAjkabBTMFQQJA5YI5NDIVYRv2QEJAxYK5GiwWDBXEV5nB+q4IaPJleyAhAHvBHI0eCuYKy+/gXPZQQkDBgRyaOTKy1ngYXZQwoAbAjkaXBfMlYdLwH6t5KuRu8lZ5VGP5E3XCHAK5TNBCW4nK3azTzzriV3HN9zm+ynGOIaiRQ/xG9/mWctEr3GoVJcVJsFtI8YS/ybll6MPl2ux+iwj3oZMe446anXlZ9mE20YMJf4w+dd/anflZ1lPuE357gL5a3nlZ2nDbSOWmfOXFcxd2ys/S4LbRuzDX/gnwPaSeU38MejCiXIZZ8hQGn3p2CH8brJ8MPENwzAMwzAMw1BF63mlBLeC2YXbMevAnelZDEwH5qT/9xn4idtsH8BtdNxPox93V2t4sgI4CFwDBim/GDcIXE1fs0Owj6YhwR1LPA68IPw+QDaeA8fSnJV5ElGDucABZI6kjxdPcacQGlNZLVgAHAW+oCf8WNPUkbS2SUsrsI8w83qs+IpbBZ0eSQM1uoFX6AvsG/3kf6qykrQAJ3DnHbVFzRsjuA/rqcFVEWIu7qidtpBl4xowP7A20ZmH+3E7bfFCxYO0p6ZgFu4OVFu00HEXvZ+vycV59MWKFRcC6hSF3eiLFDt2BlMrMC3AS/QFih3P014rx3b0xZGKrYE088bnCRnfY9+TgUoasDZ6FdVhnXRCn2VbzV8ZlGYImC2Z0MeA0ehVVAvRvQR7UFsZM0AZM0AZM0AZM0AZM0AZM0AZM0AZM8AwDMMwDMMwDMMwDMMwhPgD9+I0qRLjCc0AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtslogo);
export default __webpack_public_path__ + "static/media/ttslogo.4c24a18ad85cc59aee917abf4c3b0338.svg";
export { ForwardRef as ReactComponent };